import React, { createContext } from 'react';
import {
  compose,
  merge,
  reduceWhile,
  is,
  map,
  propEq,
  find,
  clone,
  forEachObjIndexed,
  head,
  drop,
  pluck,
  values,
  omit,
  pick
} from 'ramda';
import format from 'string-template';
import defaultValidations from './defaultValidations';

import { set, get } from '@synergycms_core/utils';

import styleFile from './form.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import Modal from '../../generic/Modal';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import FormManager from './formManager';
import loggerGetter from '@synergycms_core/utils/logger';


const FormContext = createContext({});
const formManager = FormManager();



export const withForm = () => Child => {
  return class extends React.Component {
    static displayName = 'formProvider(' + Child.displayName + ')';

    render() {

      if (Child.displayName === undefined) {
        debugger;
      }

      const { model, formContext } = this.props;
      if (formContext) {
        const form = formManager.getForm(formContext);
        return <Child
          {...this.props}
          form={form}
          formModel={get(['inputList', model], form)} />
      } else {
        return (
          <FormContext.Consumer>
            {form => {
              return (
                <Child
                  {...this.props}
                  form={form}
                  formModel={get(['inputList', model], form)}
                />
              );
            }}
          </FormContext.Consumer>
        );
      }
    }
  };
};

const form = class Form extends React.Component {
  static displayName = 'Form';
  constructor(props) {
    super(props);
    this.state = {
      validForm: false,
      inputList: {},
      requestInProgress: false,
      loading: false
    };
    const { config } = this.props;
    this.inputsPromiseList = [];
    this.getValidClass = this.getValidClass(config.css);
    this.formValidations = this.overrideBaseValidations(config.validations, defaultValidations);

    config.formContext && formManager.setForm(config.formContext, this);
  }
  componentWillUnmount = () => {
    this.mounted = false;
    /*this.inputsPromiseList.forEach(promoie => {
      promoie.cancel();
    });*/
    this.inputsPromiseList = null;
    this.manageLoading(false);

    formManager.destroyForm(this.props.config.formContext);
  };
  subscribe = input => {
    const newSbuscription = new Promise(resolve => {
      if (!this.state.inputList[input.model]) {
        const validations = this.mergeInputValidations(
          input.validations,
          this.formValidations,
          input.validationsFields
        );
        const newInput = set('validations', validations, input);

        this.setState(state => ({ inputList: set(input.model, newInput, state.inputList) }), () => {
            this.mounted && this.onGlobalChange(input.model, null, true);
          return resolve();
        });

      }
    });

    this.inputsPromiseList.push(newSbuscription);
  };

  unSubscribe = input => {
      if (this.state.inputList[input.model]) {
        this.setState(state => {
          const res = { inputList: omit([input.model], state.inputList) };
          return res;
        });
      }
  };

  updateModel = (model, newProp, callback) => {
    this.setState(state => {
      let newInputList = {};
      if (model) {
        newInputList = set([model], merge(state.inputList[model], newProp), state.inputList);
      } else {
        forEachObjIndexed(input => {
          newInputList = set(input.model, merge(input, newProp), newInputList);
        }, this.state.inputList);
      }

      return {
        inputList: newInputList
      };
    },()=> {
      callback && callback()
    });
  };

  getValidClass = (formCss = {}) => (formModel, css = {}, theme) => {
    let validClass = '';
    if (formModel.visited) {
      if (formModel.validation.valid) {
        validClass = css.valid !== null ? theme.styleGetter(css.valid || formCss.valid || 'valid') : '';
      } else {
        validClass = css.invalid !== null ? theme.styleGetter(css.invalid || formCss.invalid || 'invalid') : '';
      }
    } else {
      validClass = '';
    }
    return validClass;
  };

  componentDidMount = () => {
    Promise.all(this.inputsPromiseList).then(() => {
      if (this.inputsPromiseList) {
        this.mounted = true;
        return  this.onGlobalChange(null, null, true).then(() => {
          if (this.props.config.onMount) {
            const { validForm, inputList } = this.state;
            this.props.config.onMount(validForm, inputList, null, this.stateRetriever);
          }
        });
      }
    });
    //this.inputsPromiseList.push(globalPromise);
  };

  overrideBaseValidations = (newValidations = [], baseValidations) => {
    return map(baseValidation => {
      return merge(baseValidation, find(propEq('type', baseValidation.type), newValidations) || {});
    }, baseValidations);
  };

  mergeInputValidations = (newValidations, baseValidations, fields = {}) => {
    let newValidation;
    const content = this.props.content;
    return map(validation => {
      newValidation = is(Object, validation) ? validation : { type: validation };
      newValidation = merge(find(propEq('type', newValidation.type), baseValidations) || {}, newValidation);

      const translatedFields = merge(map(field => content.t(field), fields), newValidation);
      newValidation.validText = format(content.t(newValidation.validText), translatedFields);
      newValidation.invalidText = format(content.t(newValidation.invalidText), translatedFields);
      return newValidation;
    }, newValidations);
  };

  manageLoading = enable => {
    if (enable) {
      this.timeout = setTimeout(() => this.setState({ loading: enable }), 100);
    } else {
      this.timeout && clearTimeout(this.timeout);
      this.setState({ loading: enable });
    }
  };

  disableSubmit = (disable, persist) => {
    if(!disable && this.disableSubmitTimeout) {
      clearTimeout(this.disableSubmitTimeout);
    }
    this.setState({ requestInProgress: disable }, () => {
      if(disable) {
        this.disableSubmitTimeout = !persist && setTimeout(() => this.setState({ requestInProgress: false }), 10000);
      }
    });
  };

  getFilteredModel = ()=>{
    return this.props.config.filterInputModel?.(this.state.inputList) || this.state.inputList;
  }


  onGlobalSubmit = e => {
    e && e.preventDefault();
    const logger = loggerGetter();
    console.log("this.state.validForm",this.state.validForm);
    if (!this.submitPromise) {
      this.updateModel(null, { visited: true }, () => {
        if (this.props.config.onSubmit) {
          if (this.state.validForm) {
            this.setState({ requestInProgress: true }, () => {
              if (!this.props.config.disableLoading) {

              }
            });
          }

          this.submitPromise = this.onGlobalChange(null, null, true).then(() => {
            return this.props.config
              .onSubmit(this.state.validForm, this.getFilteredModel(), this.props.config.formVersion >= 2 ? this.stateRetriever : this.manageLoading)
              .then(result => {
                this.submitPromise = null;
                this.toggleModal && this.toggleModal(false);
                this.mounted &&
                  this.setState({ requestInProgress: false, success: true }, () => {
                    this.manageLoading(false);
                  });
                logger.cancelSend();
              })
              .catch(err => {
                logger.addLine('error submit form.jsx', err).sendMail();
                this.submitPromise = null;
                this.toggleModal && this.toggleModal(false);
                this.mounted &&
                  this.setState({ requestInProgress: false, success: false }, () => {
                    this.manageLoading(false);
                  });
              });
          }).catch(err => {
            this.submitPromise = null;
          });
        }
      });

    }
  };

  onGlobalBlur = model => {
    if (this.props.config.onBlur) {
      this.props.config.onBlur(this.state.validForm, this.getFilteredModel(), model, this.stateRetriever);
    }
  };

  onOverrideValues = (e, model, value) => {
    const inputList = this.props.config.onOverrideValues({ this: form, inputList: this.state.inputList, model, value });
    inputList && this.setState(
      state => {
        return { inputList: inputList };
      },
      () => {
        const promise = this.onGlobalChange(null, null, true);
        if (this.props.config.submitAfterOverride) {
          promise.then(() => {
            this.onGlobalSubmit();
          });
        }
      }
    );
  };

  onGlobalChange = (model, value, preventCallback) => {

    const modelList = model ? (Array.isArray(model) ? model : [model]) : pluck('model', values(this.state.inputList));

    return new Promise(resolve => {
      let newInputList = {};
      const validatedModels = modelList.map(model => {
        const currentModel = this.state.inputList[model];
        const currentValue = value !== null ? value : currentModel.value;
        return this.validate(currentValue, currentModel, currentModel.validations).then((validation) => {
          const newModel = merge(currentModel, { validation, value: currentValue });
          return (newInputList = set(model, newModel, newInputList));
        });
      });

      Promise.all(validatedModels)
        .then(() => {
          return newInputList;
        })
        .then(newInputList => {
          this.setState(
            state => {
              const inputList = merge(this.state.inputList, newInputList)
              return {
                inputList: inputList,
                validForm: this.validateForm(this.props.config.filterInputModel?.(inputList) || inputList)
              };
            },
            () => {
              //TODO s'hauria de controlar q no rebenti, tot i q no hauria de fer-ho
              modelList.forEach(model => {
                const input = this.state.inputList[model];
                const callback = input.validation.callback;
                if (callback && is(Function, callback)) {
                  callback();
                }
                if (!preventCallback && input.forceUpdateModel) {
                  input.forceUpdateModel && input.onChange(input.value, true)
                }
              });
              if (this.props.config.onChange && !preventCallback) {
                const { validForm, inputList } = this.state;
                this.props.config.onChange(validForm, this.getFilteredModel(), model, this.stateRetriever);

              }
              if (this.props.config.overrideAfterChange && this.props.config.onOverrideValues && !preventCallback) {
                this.props.config.overrideAfterChange && this.onOverrideValues(null, model, value)
              }
              resolve(this.state.inputList);
            }
          );
        });
    });
  };

  validateForm = newInputList => {
    const validForm = reduceWhile(
      (validationResult, input) => {
        return validationResult;
      },
      (validationResult, key) => {
        return !newInputList[key].validations.length || get(['validation', 'valid'], newInputList[key]) === true;
      },
      true,
      Object.keys(newInputList)
    );

    this.props.config?.onValidateForm?.(validForm, newInputList);
    return !!validForm;
  };

  stateRetriever = () => {
    return { onGlobalChange:this.onGlobalChange, validForm: this.state.validForm, inputList: this.state.inputList, manageLoading: this.manageLoading, disableSubmit : this.disableSubmit };
  };

  validate = (value, currentModel, validations) => {

    const isInvalid = validationResult => !validationResult.valid;

    const currentValidation = head(validations);
    if (!currentValidation) {
      return Promise.resolve({ valid: true, callback: null });
    }
    let validationPromise;
    const validationObj = currentValidation.method(value, currentValidation, currentModel, this.state.inputList, this);
    let newValidation = clone(currentValidation);

    if (!is(Object, validationObj) || !validationObj.then) {
      validationPromise = Promise.resolve(validationObj);
    } else {
      validationPromise = validationObj;
    }

    return validationPromise
      .then(validationObj => {
        if (is(Object, validationObj) && validationObj.callback) {
          newValidation.valid = !!validationObj.valid;
          newValidation.callback = validationObj.callback;
        } else {
          newValidation.valid = !!validationObj;
        }

        const newList = drop(1, validations);
        return newList.length && !isInvalid(newValidation)
          ? this.validate(value, currentModel, newList)
          : newValidation;
      })
      .catch(err => {
        return { ...newValidation, valid: false, err: err, callback: [] };
      });
  };

  clearValues = () => { };

  render = () => {
    const { children, theme, config } = this.props;
    const { classes } = theme.styles;
    const { loadingTemplate: LoadingTemplate } = config;
    const state = this.state;

    const formMethods = {
      validForm: state.validForm,
      requestInProgress: state.requestInProgress,
      subscribe: this.subscribe,
      unSubscribe : this.unSubscribe,
      validate: this.validate,
      onGlobalChange: this.onGlobalChange,
      onGlobalBlur: this.onGlobalBlur,
      onGlobalSubmit: this.onGlobalSubmit,
      onOverrideValues: this.onOverrideValues,
      updateModel: this.updateModel,
      inputList: state.inputList,
      overrideBaseValidations: this.overrideBaseValidations,
      getValidClass: this.getValidClass,
      manageLoading: this.manageLoading
    };


    return (
      <FormContext.Provider
        value={formMethods}>
        {LoadingTemplate && state.loading ? (
          <Modal
            innerStyle={['modalStyle']}
            contentStyle={classes.loadingModalcontent}
            closeButtonStyle={classes.closeButton}
            modalStyle={classes.loadingModalStyle}
            popover={toggleModal => {
              this.toggleModal = toggleModal;
              return <LoadingTemplate />;
            }}
            instantToggle={true}
            disableCloseOnClick={true}
            typeModal={'confirmationModal'}
          />
        ) : null}
        {!config.withoutForm ? (
          <form className={theme.computedInnerStyle} id={config.id || 'defaultForm'}>
            {children}
          </form>
        ) : (
            <div className={theme.computedInnerStyle}>{children}</div>
          )}
      </FormContext.Provider>
    );
  };
};

export default compose(
  PropertyManager([
    'children',
    'onSubmit', //callback onSubmit...F
    'validations', //tradus globals de formulari, sobrescriuen les default a nivell de tot el form
    'onChange', //callback onChange global de qualsevol input del form
    'onBlur', //callback onBlur global de qualsevol input del form
    'id', //alguns forms necessiten id
    'withoutForm', //s'utilitza per carregar el formulari cmom a div en comptes de com a form
    'onMount', // es pot passar una callback per quan es munta el component de form, aquesta rep els inputs ja muntats amb el valor default
    'loadingTemplate',
    'submitAfterOverride', //aquesta propietat dispara un submit automatic despres d'executar l'onOverrideValues
    'onOverrideValues', //callback que s'executa amb el button override,un dels exemples d'us podria ser netejar el formulari
    'overrideAfterChange',
    'disableLoading', // permet deshabilitar el loading automatic que apareix al realitzar submit, es pot activar manualment desde el submit amb el tercer argument rebut
    'formContext',
    'filterInputModel',
    'onValidateForm',
    'formVersion'
  ]),
  withThemeJSS({ styleFile, link: true, index: 20 }),
  withContent('i18n')
)(form);
